export enum RequestFormStep {
  REQUEST_DETAILS = 'requestDetails',
  AMBULANCE = 'ambulance',
  PERSONNEL = 'personnel',
  REGIONS = 'regions',
  SEND_REQUEST = 'sendRequest',
}

export enum ResponseFormStep {
  AMBULANCE = 'ambulance',
  PERSONNEL = 'personnel',
  SEND_REQUEST = 'sendRequest',
}

export enum BlastFormStep {
  RECIPIENTS = 'recipients',
  DETAILS = 'details',
}
